<div class="modal-body" id="modal-body">
  <ng-container *ngIf="contentType === 'detail'; else listBlock">
    <app-fiscal-positions-detail [pk]="pk" [mode]="mode" [defaults]="defaults"
                                   (detailSaved)="modal.close($event)"
                                   (detailCancelled)="modal.dismiss()">
    </app-fiscal-positions-detail>
  </ng-container>
  <ng-template #listBlock>
    <app-fiscal-positions-list (rowClick)="modal.close($event)" [disableUrlUpdate]="true"
                                  [disabledButtons]="disabledButtons" [disabledColumns]="disabledColumns"
                                  [filters]="filters" [disableRouterLink]="true">
    </app-fiscal-positions-list>
  </ng-template>
</div>